/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { HospitalFormSchema, updateHospitalFormSchema } from '../../schemas/HospitalFormSchema'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputLabel } from '@mui/material';
import InputController from '../../components/InputController/InputController';
import { FormContainer } from './HospitalStyle';
import { useNavigate } from 'react-router-dom';
import { useUpdateForm } from '../../context/UpdateFormProvider';

const ViewHospital = () => {
  const { updateFormValues } = useUpdateForm()

  let {
    hospital_Name = "",
    hospital_address = "",
    hospital_contact = "",
    hospital_contact_person_name = "",
    hospital_email_id = "",
    hospital_region = "",
    hospital_zio_code = "",
    password = "",
  } = updateFormValues || {};


  const isUpdate = !!Object.keys(updateFormValues || {}).length

  const navigate = useNavigate()
  const { control, formState: { errors } } = useForm({
    resolver: yupResolver(isUpdate ? updateHospitalFormSchema : HospitalFormSchema),
    mode: "onChange",
    defaultValues: {
      hospital_Name: isUpdate ? hospital_Name : "",
      hospital_email_id: isUpdate ? hospital_email_id : "",
      password: isUpdate ? "**********" : "",
      confirmPassword: isUpdate ? "**********" : "",
      hospital_contact: isUpdate ? hospital_contact : "",
      hospital_region: isUpdate ? hospital_region : "",
      hospital_contact_person_name: isUpdate ? hospital_contact_person_name : "",
      hospital_address: isUpdate ? hospital_address : "",
      hospital_zio_code: isUpdate ? hospital_zio_code : "",
    }
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    const handleLoad = () => {
      const navigationEntry = window.performance.getEntriesByType("navigation")[0];
      if (navigationEntry && navigationEntry.type === 'reload') {
        navigate('/hospital-list');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, []);


  return (
    <>
      <form>
        <InputLabel sx={{ fontSize: "1.5rem" }}>Tertiary Healthcare Facilities</InputLabel>
        <FormContainer>
          <InputController
            name="hospital_Name"
            label="Name"
            control={control}
            isLoading={true}
            errors={errors} />

          <InputController
            name="hospital_email_id"
            label="Email ID"
            control={control}
            isLoading={true}
            errors={errors} />

          <InputController
            name="hospital_contact"
            label="Contact Number"
            isNumberField={true}
            control={control}
            isLoading={true}
            errors={errors} />

          <InputController
            name="hospital_region"
            label="Region"
            control={control}
            isLoading={true}
            errors={errors} />

          <InputController
            name="hospital_contact_person_name"
            label="Contact Person Name"
            control={control}
            isLoading={true}
            errors={errors} />

          <InputController
            name="hospital_zio_code"
            label="Zip Code"
            control={control}
            isLoading={true}
            errors={errors} />


          <InputController
            name="password"
            label="Password"
            control={control}
            isLoading={true}
            errors={errors}
            isGrow
          />

          <InputController
            name="confirmPassword"
            label="Confirm Password"
            control={control}
            isLoading={true}
            errors={errors}
            isGrow
            isCustomError
          />

          <InputController
            name="hospital_address"
            label="Address"
            control={control}
            isLoading={true}
            errors={errors}
            isGrow
          />
        </FormContainer>
      </form>


    </>
  )
}

export default ViewHospital